import { defineStore } from 'pinia';
import { strapi } from '../transport/strapi';
import type { ISystemHostData, ISystemHostStrapiResponse } from '~/types/systemHosts';

export const useStoreSystemHosts = defineStore('systemHosts', {
  state: () => ({
    systemHost: null as ISystemHostData | null,
    requestPromise: null as Promise<ISystemHostStrapiResponse> | null,
  }),

  getters: {
    current(): ISystemHostData | null {
      return this.systemHost;
    },
    regional(): string {
      return this.current?.regionalVisibleDomain || '7bitcasino.com';
    },
  },

  actions: {
    async loadSystemHost() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('system-hosts', `filters[host][$eq]=${window.location.host}`)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data && response.data[0]) {
        this.systemHost = response.data[0];

        return true;
      } else {
        return false;
      }
    },
  },
});
